module.exports = __webpack_public_path__ + "static/placeholder-22959c29cf1c3c093b68307d4e8fcd4c.png";